export default __webpack_public_path__ + "static/media/step-2-en.bd94affb.svg";